(function () {
  const menu = document.getElementById('bjaf-mobile-menu');
  const scrim = document.getElementById('bjaf-mobile-menu-scrim');

  if (!menu || !scrim) {
    return;
  }

  if (menu.parentElement !== document.body) {
    document.body.appendChild(scrim);
    document.body.appendChild(menu);
  }

  const toggles = document.querySelectorAll('[aria-controls="bjaf-mobile-menu"]');
  const closeButtons = document.querySelectorAll('[data-bjaf-mobile-menu-close]');
  const accordions = menu.querySelectorAll('.bjaf-mobile-menu__accordion');

  function openMenu() {
    menu.hidden = false;
    scrim.hidden = false;
    requestAnimationFrame(function () {
      menu.classList.add('is-open');
      scrim.classList.add('is-open');
    });
    menu.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bjaf-mobile-menu-open');
    toggles.forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
    });
  }

  function closeMenu() {
    menu.classList.remove('is-open');
    scrim.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bjaf-mobile-menu-open');
    toggles.forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    });

    window.setTimeout(function () {
      if (!menu.classList.contains('is-open')) {
        menu.hidden = true;
        scrim.hidden = true;
      }
    }, 320);
  }

  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (menu.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeMenu);
  });

  scrim.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && menu.classList.contains('is-open')) {
      closeMenu();
    }
  });

  accordions.forEach(function (button) {
    button.addEventListener('click', function () {
      const group = button.closest('.bjaf-mobile-menu__group');
      const isOpen = group.classList.contains('is-open');

      menu.querySelectorAll('.bjaf-mobile-menu__group.is-open').forEach(function (openGroup) {
        if (openGroup !== group) {
          openGroup.classList.remove('is-open');
          openGroup.querySelector('.bjaf-mobile-menu__accordion')?.setAttribute('aria-expanded', 'false');
        }
      });

      group.classList.toggle('is-open', !isOpen);
      button.setAttribute('aria-expanded', String(!isOpen));
    });
  });
})();
